import axios from 'axios'
import {apiDomain} from '../../config'

export default {
  getAll () {
	return new Promise((resolve, reject) => {
		axios.get(apiDomain + '/terminal_agreements/', { headers: {
			'Content-Type': 'application/json', 'token': localStorage.getItem('access_token')
,		}})
	  	.then((response) => {
		    if (response.data.status === 'success') {
            	var data = [response.data.status, response.data.t_agreements, response.data.insert_data || [], response.data.role, response.data.energy_company_id]
            	resolve(response.data)
        } else {
            	var data = [response.data.status, response.data.message]
            	resolve(response.data) }
		        })
		.catch((error) => {
		    reject(error)
		})
    })
	},
	save ( model ) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/terminal_agreements/create/', model, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = [response.data.status, response.data.message]
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getBy ( terminalId ) {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/terminal_agreement/' + terminalId + '/', { headers: {
				'Content-Type': 'application/json',
    			'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					if (response.data.status === 'success') {
						var data = [response.data.status, response.data.t_agreement, response.data.update_data || [], response.data.role, response.data.energy_company_id ]
						resolve(data)
					} else {
						var data = [response.data.status, response.data.message]
						resolve(data) }
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	delete ( terminalID ) {
		return new Promise((resolve, reject) => {
			axios.delete(apiDomain + '/terminal_agreement/delete/' + terminalID + '/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = [response.data.status, response.data.message]
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	update ( terminalID, model ) {
		return new Promise((resolve, reject) => {
			axios.put(apiDomain + '/terminal_agreement/update/' + terminalID + '/', model, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = [response.data.status, response.data.message]
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getEnergyCompaniesUnload( locationId ){
		return new Promise((resolve, reject) => {
		  axios.get(apiDomain + '/energy_company_location_unload/' + locationId + '/', { headers: {
			'Content-Type': 'application/json', 'token': localStorage.getItem('access_token')
		  }})
			.then((response) => {
			  if (response.data.status === 'success') {
				var data = [response.data.status, response.data.energycompanies]
				resolve(data)
			  } else {
				  var data = [response.data.status, response.data.message]
				resolve(data) } })
			.catch((error) => {
				reject(error)
			})
		})
	},
	restore ( id ) {
		return new Promise((resolve, reject) => {
			axios.delete(apiDomain + '/terminal_agreement/restore/' + id + '/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = [response.data.status, response.data.message]
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	update1 ( model ) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/terminal_agreement/update1/', model, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = [response.data.status, response.data.message]
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},	
	saveTCL ( model ) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/terminal_company_location/create/', model, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = [response.data.status, response.data.message]
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	get_indexes () {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/indexes/', { headers: {
				'Content-Type': 'application/json', 'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					if (response.data.status === 'success') {
								var data = [response.data.status, response.data.t_agreements, response.data.insert_data || [], response.data.role, response.data.energy_company_id]
								resolve(response.data)
					} else {
								var data = [response.data.status, response.data.message]
								resolve(response.data) }
							})
			.catch((error) => {
					reject(error)
			})
			})
		},
	save_indexes ( model ) {
			return new Promise((resolve, reject) => {
				axios.post(apiDomain + '/indexes/create/', model, { headers: {
					'Content-Type': 'application/json',
						'token': localStorage.getItem('access_token')
				}})
					.then((response) => {
						var data = [response.data.status, response.data.message]
						resolve(data)
					})
					.catch((error) => {
						reject(error)
					})
			})
		},
		getByIndex ( indexId ) {
			return new Promise((resolve, reject) => {
				axios.get(apiDomain + '/index/' + indexId + '/', { headers: {
					'Content-Type': 'application/json',
						'token': localStorage.getItem('access_token')
				}})
					.then((response) => {
						if (response.data.status === 'success') {
								resolve(response.data)
						} else {
								resolve(response.data) 
						}
					})
					.catch((error) => {
						reject(error)
					})
			})
		},
		delete_index ( indexID ) {
			return new Promise((resolve, reject) => {
				axios.delete(apiDomain + '/index/delete/' + indexID + '/', { headers: {
					'Content-Type': 'application/json',
						'token': localStorage.getItem('access_token')
				}})
					.then((response) => {
						var data = [response.data.status, response.data.message]
						resolve(data)
					})
					.catch((error) => {
						reject(error)
					})
			})
		},
		update_index ( indexID, model ) {
			return new Promise((resolve, reject) => {
				axios.put(apiDomain + '/index/update/' + indexID + '/', model, { headers: {
					'Content-Type': 'application/json',
						'token': localStorage.getItem('access_token')
				}})
					.then((response) => {
						var data = [response.data.status, response.data.message]
						resolve(data)
					})
					.catch((error) => {
						reject(error)
					})
			})
		},
		get_wti () {
			return new Promise((resolve, reject) => {
				axios.get(apiDomain + '/wti/', { headers: {
					'Content-Type': 'application/json', 'token': localStorage.getItem('access_token')
				}})
					.then((response) => {
						if (response.data.status === 'success') {
									//var data = [response.data.status, response.data.t_agreements, response.data.insert_data || [], response.data.role, response.data.energy_company_id]
									resolve(response.data)
						} else {
									// var data = [response.data.status, response.data.message]
									resolve(response.data) }
								})
				.catch((error) => {
						reject(error)
				})
				})
			},
		save_wti ( model ) {
				return new Promise((resolve, reject) => {
					axios.post(apiDomain + '/wti/create/', model, { headers: {
						'Content-Type': 'application/json',
							'token': localStorage.getItem('access_token')
					}})
						.then((response) => {
							var data = [response.data.status, response.data.message]
							resolve(data)
						})
						.catch((error) => {
							reject(error)
						})
				})
			},
			getByWti ( wtiId ) {
				return new Promise((resolve, reject) => {
					axios.get(apiDomain + '/wti/' + wtiId + '/', { headers: {
						'Content-Type': 'application/json',
							'token': localStorage.getItem('access_token')
					}})
						.then((response) => {
							if (response.data.status === 'success') {
									resolve(response.data)
							} else {
									resolve(response.data) 
							}
						})
						.catch((error) => {
							reject(error)
						})
				})
			},
			delete_wti ( wtiID ) {
				return new Promise((resolve, reject) => {
					axios.delete(apiDomain + '/wti/delete/' + wtiID + '/', { headers: {
						'Content-Type': 'application/json',
							'token': localStorage.getItem('access_token')
					}})
						.then((response) => {
							var data = [response.data.status, response.data.message]
							resolve(data)
						})
						.catch((error) => {
							reject(error)
						})
				})
			},
			update_wti ( wtiID, model ) {
				return new Promise((resolve, reject) => {
					axios.put(apiDomain + '/wti/update/' + wtiID + '/', model, { headers: {
						'Content-Type': 'application/json',
							'token': localStorage.getItem('access_token')
					}})
						.then((response) => {
							var data = [response.data.status, response.data.message]
							resolve(data)
						})
						.catch((error) => {
							reject(error)
						})
				})
			},
			restoreWti ( id ) {
				return new Promise((resolve, reject) => {
					axios.delete(apiDomain + '/wti/restore/' + id + '/', { headers: {
						'Content-Type': 'application/json',
							'token': localStorage.getItem('access_token')
					}})
						.then((response) => {
							var data = [response.data.status, response.data.message]
							resolve(response.data)
						})
						.catch((error) => {
							reject(error)
						})
				})
			},
			restoreIndex ( id ) {
				return new Promise((resolve, reject) => {
					axios.delete(apiDomain + '/index/restore/' + id + '/', { headers: {
						'Content-Type': 'application/json',
							'token': localStorage.getItem('access_token')
					}})
						.then((response) => {
							var data = [response.data.status, response.data.message]
							resolve(response.data)
						})
						.catch((error) => {
							reject(error)
						})
				})
			},
			get_attr_ta (){
				return new Promise((resolve, reject) => {
					axios.get(apiDomain + '/ta_attr/', { headers: {
						'Content-Type': 'application/json',
						'token': localStorage.getItem('access_token')
					}})
						.then((response) => {
							  if (response.data.status === 'success') {
								var data = [response.data.status, response.data.insert_data]
								resolve(response.data)
							} else {
								var data = [response.data.status, response.data.message]
								resolve(response.data)
							}
						})
						.catch((error) => {
							  reject(error)
						})
				})
			},
}



// WEBPACK FOOTER //
// ./src/views/terminal_agreements/t_agreement.js